import { useIndexAgents } from "@circle-react/components/SettingsApp/CommunityBot/agentsQueries";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useEffect, useState } from "react";

import { t } from "@/i18n-js/instance";
import { IconButton } from "@/react/components/shared/uikit/HeaderV3/IconButton";
import { PAGE_SURFACE } from "@/react/constants/pageSurface";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type {
  Agent,
  ChatSortType,
  ChatType,
} from "@/react/types/CommunityBot/ChatSort";

import { AgentDropdownComponent } from "./AgentDropdown/AgentDropdownComponent";
import { ChatTypesDropdownComponent } from "./ChatTypesDropdown/ChatTypesDropdownComponent";
import { ALL_AGENTS_INITIAL_STATE, CHAT_SORT_VALUES } from "./constants";
import { DropdownMenuComponent } from "./DropdownMenu/DropdownMenuComponent";

interface HeaderProps {
  activeAgent: Agent;
  activeChatType: ChatType;
  activeSort: ChatSortType;
  setActiveAgent: (value: Agent) => void;
  setActiveChatType: (value: ChatType) => void;
  setActiveSort: (value: ChatSortType) => void;
  setIsSearchBarVisible: (value: boolean) => void;
}
export const Header = ({
  activeSort,
  setActiveSort,
  activeChatType,
  setActiveChatType,
  activeAgent,
  setActiveAgent,
  setIsSearchBarVisible,
}: HeaderProps) => {
  const [agents, setAgents] = useState<Agent[]>([ALL_AGENTS_INITIAL_STATE]);
  const { data: agentResults } = useIndexAgents({ currentPage: 1 });

  useEffect(() => {
    if (agentResults?.records && agentResults.records.length > 0) {
      setAgents([ALL_AGENTS_INITIAL_STATE, ...agentResults.records]);
    }
  }, [agentResults]);

  return (
    <div
      className={classNames(
        "sticky top-0 z-10 my-1 flex h-10 items-center justify-between gap-2 pl-2 pr-3",
        PAGE_SURFACE,
      )}
    >
      <div className="flex min-w-0 items-center gap-2">
        <div className="shrink-0">
          <ChatTypesDropdownComponent
            activeItem={activeChatType}
            localeScope="community_inbox.filters"
            onItemClick={setActiveChatType}
            dataTestId="chat-types-dropdown"
          />
        </div>
        <div className="grid min-w-0 flex-1 grid-cols-1">
          <AgentDropdownComponent
            activeItem={activeAgent}
            onItemClick={value => setActiveAgent(value)}
            items={agents}
            dataTestId="agent-dropdown"
          />
        </div>
        <div className="flex shrink-0 items-center">
          <DropdownMenuComponent
            items={Object.values(CHAT_SORT_VALUES)}
            activeItem={activeSort}
            localeScope="community_inbox.filters"
            onItemClick={setActiveSort}
            dataTestId="sort-filter-dropdown"
            align="end"
          />
          <Tooltip content={t("community_inbox.header.search_messages")}>
            <span>
              <IconButton
                iconSize={20}
                buttonSize={24}
                name="20-search-v3"
                ariaLabel={t("community_inbox.header.search_messages")}
                className="!rounded-full"
                onClick={() => setIsSearchBarVisible(true)}
              />
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
